import * as React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const CloseIcon = ({ width = 32, height = 32, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    focusable="false"
    {...props}
  >
    <path
      d="M8.12696 24.1211L24.127 8.12109"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.12695 8.12305L24.127 24.123"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

CloseIcon.displayName = 'CloseIcon'
